(() => {
  const VARIANTS_BY_PATH = {
    '/products/titan-surge-pre-workout-fizzy-cola-bottles': 54179361554773,
    '/products/the-workout-bundle': 54179366633813,
    '/products/creatine-monohydrate-500g': 52090778714453,
    '/products/eaa': 52205539754325,
    '/products/hydros': 52872948154709,
    '/products/l-glutamine-500g': 52090956579157,
    '/products/titan-tri-carb': 52205731119445,
    '/products/the-performance-bundle': 54179328360789,
    '/products/the-recovery-bundle': 54179310076245,
    '/products/hybrid-bundle': 54178972959061,
    '/products/xxl-2-2-ltr-jug': 52093046423893,
    '/products/zmb': 52393901228373,
    '/products/iron': 52359458881877,
    '/products/vitamin-c': 52359452492117,
    '/products/d3-k2': 52316707619157,
    '/products/ashwagandha-ksm-66': 52090726187349,
    '/products/hypnos': 52359511605589,
    '/products/testus-maximus': 52309808415061,
    '/products/shilajit-capsules': 52090990068053,
    '/products/turkesterone-600mg': 52093038821717,
  };

  let cartDrawerWasOpen = false;

  function getPath(url) {
    try {
      return new URL(url, window.location.origin).pathname.replace(/\/$/, '');
    } catch (error) {
      return '';
    }
  }

  function getProductLink(card) {
    return card.matches('a[href]') ? card : card.querySelector('a[href]');
  }

  function isVisible(element) {
    if (!(element instanceof HTMLElement)) return false;
    const rect = element.getBoundingClientRect();
    const styles = window.getComputedStyle(element);
    return rect.width > 0 && rect.height > 0 && styles.display !== 'none' && styles.visibility !== 'hidden';
  }

  function isCartDrawerOpen() {
    const dialog = document.querySelector('cart-drawer-component .cart-drawer__dialog, .cart-drawer__dialog');
    return isVisible(dialog);
  }

  function enhanceUpsellCard(card) {
    if (card.dataset.upsellActionsReady === 'true') return;

    const link = getProductLink(card);
    if (!link) return;

    const variantId = VARIANTS_BY_PATH[getPath(link.getAttribute('href'))];
    if (!variantId) return;

    card.dataset.upsellActionsReady = 'true';
    card.dataset.variantId = String(variantId);

    const actions = document.createElement('div');
    actions.className = 'product-stack-upsell__actions';
    actions.dataset.variantId = String(variantId);
    actions.innerHTML = `
      <button class="product-stack-upsell__action product-stack-upsell__action--add" type="button" data-upsell-direct-add data-variant-id="${variantId}">
        Add
      </button>
      <a class="product-stack-upsell__action product-stack-upsell__action--view" href="${link.href}">
        View
      </a>
    `;

    card.append(actions);
  }

  function enhanceUpsells() {
    document
      .querySelectorAll('.product-stack-upsell__card, .product-stack-upsell__hero')
      .forEach(enhanceUpsellCard);
  }

  function removeDrawerUpsells() {
    document
      .querySelectorAll('cart-drawer-component cart-bundle-upsell[data-pantheon-cart-upsells]')
      .forEach((element) => element.remove());
  }

  function openCartDiscountDisclosure() {
    const drawer = document.querySelector('cart-drawer-component');
    if (!drawer) return;

    const trigger = drawer.querySelector('.cart-actions .cart-discount .disclosure-trigger');
    if (trigger instanceof HTMLButtonElement && trigger.getAttribute('aria-expanded') !== 'true') {
      trigger.click();
    }

    const content = drawer.querySelector('.cart-actions .cart-discount .disclosure-content');
    if (content instanceof HTMLElement) {
      content.removeAttribute('inert');
    }
  }

  function openCartDrawerAndDiscount() {
    const drawer = document.querySelector('cart-drawer-component');
    drawer?.open?.();

    window.setTimeout(openCartDiscountDisclosure, 120);
    window.setTimeout(openCartDiscountDisclosure, 450);
    window.setTimeout(openCartDiscountDisclosure, 1000);
  }

  function scheduleCartDrawerOpen() {
    window.setTimeout(openCartDrawerAndDiscount, 450);
    window.setTimeout(openCartDrawerAndDiscount, 1100);
    window.setTimeout(openCartDrawerAndDiscount, 2000);
  }

  function syncCartDrawerState() {
    const isOpen = isCartDrawerOpen();
    if (isOpen && !cartDrawerWasOpen) {
      cartDrawerWasOpen = true;
      window.setTimeout(openCartDiscountDisclosure, 80);
      window.setTimeout(openCartDiscountDisclosure, 350);
    } else if (!isOpen) {
      cartDrawerWasOpen = false;
    }
  }

  async function getCart() {
    try {
      const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      if (!response.ok) return null;
      return response.json();
    } catch (error) {
      return null;
    }
  }

  function updateCartCount(cart) {
    if (!cart || typeof cart.item_count !== 'number') return;

    const count = String(cart.item_count);
    document
      .querySelectorAll(
        [
          '[data-cart-count]',
          '.cart-count',
          '.cart-count-bubble',
          '.cart-bubble',
          'cart-icon-bubble',
          '[id*="cart-count"]',
          '[class*="cart-count"]',
        ].join(',')
      )
      .forEach((element) => {
        if (!(element instanceof HTMLElement)) return;

        element.textContent = count;
        element.setAttribute('aria-label', `${count} items in cart`);
        element.classList.remove('hidden', 'visually-hidden');
      });
  }

  function emitCartEvents(cart) {
    removeDrawerUpsells();
    updateCartCount(cart);
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
    document.dispatchEvent(new CustomEvent('cart:update', { detail: { cart } }));
    document.dispatchEvent(new CustomEvent('cart:change', { detail: { cart } }));
    openCartDrawerAndDiscount();
  }

  async function addVariant(button) {
    const variantId = Number(button.dataset.variantId || button.closest('[data-variant-id]')?.dataset.variantId);
    if (!variantId) return;

    const originalText = button.textContent;
    button.disabled = true;
    button.textContent = 'Adding';

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1,
          sections_url: window.location.pathname,
        }),
      });

      const data = await response.json();
      if (!response.ok || data.status) {
        throw new Error(data.description || data.message || 'Unable to add item');
      }

      const cart = await getCart();
      button.textContent = 'Added';
      emitCartEvents(cart);
    } catch (error) {
      button.textContent = 'Retry';
    } finally {
      window.setTimeout(() => {
        button.disabled = false;
        button.textContent = originalText;
      }, 1400);
    }
  }

  document.addEventListener(
    'click',
    (event) => {
      const button = event.target instanceof Element ? event.target.closest('[data-upsell-direct-add]') : null;
      if (!button) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      addVariant(button);
    },
    true
  );

  document.addEventListener(
    'click',
    (event) => {
      const addButton = event.target instanceof Element ? event.target.closest('button[type="submit"], button[name="add"], .add-to-cart-button') : null;
      if (!addButton || addButton.closest('[data-upsell-direct-add]')) return;
      const addForm = addButton.closest('form[action*="/cart/add"]');
      if (addForm) scheduleCartDrawerOpen();
    },
    true
  );

  document.addEventListener(
    'click',
    (event) => {
      const cartTrigger = event.target instanceof Element ? event.target.closest('cart-drawer-component .header-actions__action') : null;
      if (cartTrigger) {
        window.setTimeout(syncCartDrawerState, 120);
        window.setTimeout(syncCartDrawerState, 450);
      }
    },
    true
  );

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target instanceof HTMLFormElement ? event.target : null;
      if (form?.matches('form[action*="/cart/add"]')) scheduleCartDrawerOpen();
    },
    true
  );

  document.addEventListener('DOMContentLoaded', () => {
    enhanceUpsells();
    removeDrawerUpsells();
    openCartDiscountDisclosure();
    window.setTimeout(enhanceUpsells, 500);
    window.setTimeout(enhanceUpsells, 1500);
    window.setTimeout(removeDrawerUpsells, 800);

    const observer = new MutationObserver(syncCartDrawerState);
    observer.observe(document.body, {
      attributes: true,
      childList: true,
      subtree: true,
      attributeFilter: ['class', 'open', 'style'],
    });
  });

  document.addEventListener('cart:refresh', openCartDiscountDisclosure);
  document.addEventListener('cart:updated', openCartDiscountDisclosure);
  document.addEventListener('cart:update', openCartDiscountDisclosure);
  document.addEventListener('cart:change', openCartDiscountDisclosure);
  document.addEventListener('cart:add', openCartDrawerAndDiscount);
})();
